let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("56cs9")).then(() => parcelRequire('gf2wp'));